module.exports = __webpack_public_path__ + "img/registrate-llamada.c3d3c0e5.png";